<template>
  <div class="container-fluid"></div>
</template>

<script>
import axios from "axios";
export default {
  name: "OauthRegister",
  methods: {
    getUserData(token) {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/user/me", {
          params: { },
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
        .then((response) => {
          if(response.data && (response.data.emailVerified || ['google', 'facebook'].includes(response.data.provider))) {
            this.$store.dispatch("auth/setLogin", {
              ...response.data,
              ...{token: token}
            });
            const redirect = this.$route.query.redirect;
            if (redirect) {
              this.$router.push(redirect);
            } else {
              const roleNames = (response.data.roles || []).map((role) => role.name);
              const hasAcademicAdmin = roleNames.includes("ROLE_ACADEMIC_ADMIN");
              const hasStudentRole = roleNames.includes("ROLE_STUDENT");
              const hasAdminRole = roleNames.includes("ROLE_ADMIN");
              if (hasAcademicAdmin && (hasStudentRole || hasAdminRole)) {
                this.$router.push("/v2/auth/role-select");
                return;
              }
              if (hasAcademicAdmin) {
                this.$router.push("/teacher/groups");
                return;
              }
              this.$router.push("/dashboard");
            }
          } else {
            this.$store.dispatch("auth/logout");
            this.$toasted.info("Por favor verifica tu email para continuar.", {position: 'top-center', duration: 3000});
          }
        })
        .catch((err) => {
          this.$store.dispatch("auth/logout");
          this.$router.push({
            path: "/v2/auth/login",
            query: this.$route.query.redirect
              ? { redirect: this.$route.query.redirect }
              : {},
          });
          this.$toasted.error("Usuario inválido, por favor contacte a un administrador.", {position: 'top-center', duration: 3000});
        })
        .finally(() => {
          loader.hide();
        });
    }
  },
  mounted() {
    const token = this.$route.query.token;
    const error = this.$route.query.error;

    // Si estamos en una ventana popup (abierta por window.open), comunicar el resultado a la ventana principal
    if (window.opener && !window.opener.closed) {
      if (token) {
        try {
          // Enviar el token a la ventana principal
          window.opener.postMessage({
            type: 'googleAuth',
            token: token
          }, window.location.origin);

          // Cerrar la ventana popup después de un breve delay
          setTimeout(() => {
            window.close();
          }, 500);
        } catch (e) {
          // Si falla el postMessage, procesar normalmente
          this.getUserData(token);
        }
        return;
      } else if (error) {
        try {
          // Enviar el error a la ventana principal
          window.opener.postMessage({
            type: 'googleAuth',
            error: error
          }, window.location.origin);
          setTimeout(() => {
            window.close();
          }, 500);
        } catch (e) {
          window.localStorage.setItem("loginError", error);
          this.$router.push({
            path: "/v2/auth/login",
            query: this.$route.query.redirect
              ? { error: error, redirect: this.$route.query.redirect }
              : { error: error },
          });
        }
        return;
      }
    }
    
    // Si no estamos en una ventana popup, procesar normalmente
    if (token) {
      this.getUserData(token);
    } else if (error) {
      window.localStorage.setItem("loginError", error);
      this.$router.push({
        path: "/v2/auth/login",
        query: this.$route.query.redirect
          ? { error: error, redirect: this.$route.query.redirect }
          : { error: error },
      });
    } else {
      this.$router.push({
        path: "/v2/auth/login",
        query: this.$route.query.redirect
          ? { redirect: this.$route.query.redirect }
          : {},
      });
    }
  },
};
</script>

<style scoped></style>
